import "../../assets/styles/colors.css";

function RenameInput({
  editingNodeId,
  editingLabel,
  nodes,
  reactFlowInstance,
  reactFlowWrapper,
  onLabelChange,
  onSave,
  onCancel,
}) {
  if (!editingNodeId || !reactFlowInstance || !reactFlowWrapper) return null;

  const editingNode = nodes.find((n) => n.id === editingNodeId);
  if (!editingNode) return null;

  const nodeElement = document.querySelector(`[data-id="${editingNode.id}"]`);
  if (!nodeElement) return null;

  const nodeRect = nodeElement.getBoundingClientRect();
  const containerRect = reactFlowWrapper.getBoundingClientRect();
  const spacing = -30;
  const leftOffset = -28;
  const left =
    nodeRect.left - containerRect.left + nodeRect.width / 2 + leftOffset;
  const top = nodeRect.bottom - containerRect.top + spacing;

  return (
    <div
      className="absolute z-[1001]"
      style={{
        left: `${left}px`,
        top: `${top}px`,
        transform: "translateX(-50%)",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="bg-white dark:bg-black rounded-md p-1.5 shadow-[0_4px_12px_rgba(0,0,0,0.15)] border border-slate-200 dark:border-[var(--color-primary)] flex items-center gap-1 min-w-[120px]">
        <input
          type="text"
          className="flex-1 px-1 py-1.5 border border-slate-200 dark:border-[var(--color-border)] rounded text-sm text-slate-900 dark:text-[var(--color-text-white)] placeholder:text-slate-400 dark:placeholder:text-gray-500 focus:border-[var(--color-primary)] focus:shadow-[0_0_0_3px_var(--color-primary-100)] outline-none bg-white dark:bg-black"
          value={editingLabel}
          onChange={(e) => onLabelChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onSave();
            } else if (e.key === "Escape") {
              onCancel();
            }
          }}
          autoFocus
        />
        <div className="flex gap-1">
          <button
            className="bg-[var(--color-primary)] text-white dark:text-black w-6 h-6 p-0 border-none rounded cursor-pointer text-sm flex items-center justify-center transition-all duration-150 hover:shadow-[0_0_8px_var(--color-shadow-primary-hover)]"
            onClick={onSave}
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="w-3.5 h-3.5"
            >
              <path d="M20 6L9 17l-5-5" />
            </svg>
          </button>
          <button
            className="bg-red-500 dark:bg-red-600 text-white dark:text-[var(--color-text-white)] w-6 h-6 p-0 border-none rounded cursor-pointer text-sm flex items-center justify-center transition-all duration-150 hover:bg-red-600 dark:hover:bg-red-700"
            onClick={onCancel}
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="w-3.5 h-3.5"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}

export default RenameInput;
